var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<table ng-if=\"$ctrl.flipDatesCtrl.flipDates\"><div class=\"table-hover\"><tbody><tr ng-repeat=\"key in $ctrl.flipDatesCtrl.flipDates | sortedKeys\" ng-if=\"$ctrl.flipDatesCtrl.flipDates[key] &amp;&amp; key !== &quot;id&quot;\"><th>{{key | pretty | titlecase}}</th><td>{{$ctrl.flipDatesCtrl.flipDates[key] | amDateFormat:$ctrl.FORMAT}}</td></tr></tbody></div></table>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/components/od-flip-dates.jade
 ** module id = 687
 ** module chunks = 0 1 3 4 5 6
 **/